export const CONVERSION_STATUS = {
  PENDING: "PENDING", // Application is waiting for review
  ACCEPTED: "ACCEPTED", // Application was rejected
  PAID: "PAID", // Need to create connected account for payout
  CONVERTED: "CONVERTED", // Affiliate is active
};